import { render, staticRenderFns } from "./WorkingCapitalV2.vue?vue&type=template&id=0c70c8bb"
import script from "./WorkingCapitalV2.vue?vue&type=script&lang=js"
export * from "./WorkingCapitalV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports